export default __webpack_public_path__ + "static/genesis_hero-683203ba811d7d68d7f19dd9f320024a.png";